<template>
  <b-card :title="this.socialMedia.charAt(0).toUpperCase() + this.socialMedia.substring(1) + ' Automation'">
    <b-card-text id="ysyExtensionStateBtn" :key="this.socialMedia">
      Please install YourSynchronicity extension to fully use our automation tools.
      <b-button v-if="!this.exceptional_notice" variant="success" :href=this.extension_url @click="navigatorDetection" target="_blank">Install
        extension
      </b-button>
      <p v-if="this.exceptional_notice" style="color: red"> Please use Chrome or Firefox for a better experience with our latest extension,
        for an easier usage.</p>
    </b-card-text>
    <span id="ysy:automation"></span>
    <b-button id="ysyExtensionNewSetupCookieButton"
              v-bind:social-media="this.socialMedia"
              ref="ButtonExtensionRef"
              variant="info">Refresh my
      cookie
      credentials
    </b-button>
    <div>
      <b-button id="ysyExtensionNewSendCookieButton" @click="pushCookieCredentials" style="display: none"/>
    </div>


  </b-card>
</template>

<script>

export default {
  name: "YourSynchronicityExtension",

  props: {
    'socialMedia': String,
  },
  data() {
    return {
      data_ysy_extension: true,
      ysy_cookie_holder: null,
      extension_url: null,
      exceptional_notice: false,
    };
  },
  methods: {

    pushCookieCredentials() {
      const prefixCookieYsy = "ysyCookieHolder_"
      const ysyCookie = {}
      const allCookieYsy = this.$cookies.keys()
      var self = this
      console.log('_all_cookie_ysy', allCookieYsy)
      allCookieYsy.forEach(function (cookieKey) {
        console.log(cookieKey);
        if (cookieKey.includes(prefixCookieYsy)) {
          console.log(cookieKey.split(prefixCookieYsy))
          ysyCookie[cookieKey.split(prefixCookieYsy)[1]] = self.$cookies.get(cookieKey)
          self.$cookies.remove(cookieKey)
        }
      });
      console.log("this.ysy_cookie_holder", ysyCookie)
      let email_automation
      if (this.socialMedia === "linkedin") {
        email_automation = this.$store.getters.getEmailLinkedin
      } else {
        email_automation = this.$store.getters.getEmailLinkedin
      }
      const payload = {
        "cookie": ysyCookie,
        "ysy_username": this.$store.getters.getUser,
        "email_automation": email_automation,
        "social_media": this.socialMedia

      }
      const path = this.BACKEND_YSY + "/linkedin/initPin";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      this.$http
        .post(path, payload, {headers})
    },

    navigatorDetection() {
      if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {

        this.exceptional_notice = true
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        this.extension_url = "https://chrome.google.com/webstore/detail/yoursynchronicity/ggeapnejjbjbnlhmaabbdliakffhcloj"

      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        this.exceptional_notice = true

      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        this.extension_url = "https://addons.mozilla.org/en-US/firefox/addon/yoursynchronicity/"
      } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
      {
        this.exceptional_notice = true
      } else {
        this.exceptional_notice = true
      }
    }
  },
  mounted() {
    this.navigatorDetection()
  }
}

</script>

<style scoped>

</style>

